var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-tab-pane", { attrs: { name: "invoicing" } }, [
    _c("div", { staticClass: "row gutter-x-md justify-start" }, [
      _c("div", { staticClass: "col-md-3 col-12" }, [
        _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
          _vm._v(_vm._s(_vm.$t("invoice_number")))
        ]),
        _c("p", { staticClass: "text-faded" }, [
          _vm._v(_vm._s(_vm.$t("invoice_number_hint")))
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-md-9 col-12" },
        [
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("invoice_number_format"),
                labelWidth: 3,
                error: _vm.errors.has("invoiceNumberFormat"),
                "error-label": _vm.errors.first("invoiceNumberFormat")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|min:1|max:255",
                    expression: "'required|min:1|max:255'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "invoiceNumberFormat",
                  placeholder: _vm.$t("invoice_number_format")
                },
                model: {
                  value: _vm.formData.invoiceNumberFormat,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "invoiceNumberFormat", $$v)
                  },
                  expression: "formData.invoiceNumberFormat"
                }
              }),
              _c(
                "div",
                { staticClass: "row items-center q-mt-xs" },
                [
                  _c("q-tooltip", {
                    attrs: { anchor: "top left" },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("invoice_number_format_hint") +
                          _vm.invoiceNumberFormatExample
                      )
                    }
                  }),
                  _c("q-icon", { attrs: { name: "info", color: "grey-5" } }),
                  _c("span", { staticClass: "q-ml-xs text-grey-5" }, [
                    _vm._v(_vm._s(_vm.$tc("placeholder", 2)))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("next_invoice_number"),
                labelWidth: 3,
                error: _vm.errors.has("currentInvoiceNumber"),
                "error-label": _vm.errors.first("currentInvoiceNumber")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|min:1|max:255",
                    expression: "'required|min:1|max:255'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "currentInvoiceNumber",
                  placeholder: _vm.$t("next_invoice_number")
                },
                model: {
                  value: _vm.formData.currentInvoiceNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "currentInvoiceNumber", $$v)
                  },
                  expression: "formData.currentInvoiceNumber"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("reset_invoice_numbers"),
                "label-width": 3
              }
            },
            [
              _c("sequential-number-reset-input", {
                model: {
                  value: _vm.formData.resetInvoiceNumbers,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "resetInvoiceNumbers", $$v)
                  },
                  expression: "formData.resetInvoiceNumbers"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("quote_number_format"),
                labelWidth: 3,
                error: _vm.errors.has("quoteNumberFormat"),
                "error-label": _vm.errors.first("quoteNumberFormat")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|min:1|max:255",
                    expression: "'required|min:1|max:255'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "quoteNumberFormat",
                  placeholder: _vm.$t("quote_number_format")
                },
                model: {
                  value: _vm.formData.quoteNumberFormat,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "quoteNumberFormat", $$v)
                  },
                  expression: "formData.quoteNumberFormat"
                }
              }),
              _c(
                "div",
                { staticClass: "row items-center q-mt-xs" },
                [
                  _c("q-tooltip", {
                    attrs: { anchor: "top left" },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("quote_number_format_hint") +
                          _vm.quoteNumberFormatExample
                      )
                    }
                  }),
                  _c("q-icon", { attrs: { name: "info", color: "grey-5" } }),
                  _c("span", { staticClass: "q-ml-xs text-grey-5" }, [
                    _vm._v(_vm._s(_vm.$tc("placeholder", 2)))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("next_quote_number"),
                labelWidth: 3,
                error: _vm.errors.has("currentInvoiceNumber"),
                "error-label": _vm.errors.first("currentInvoiceNumber")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|min:1|max:255",
                    expression: "'required|min:1|max:255'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "currentQuoteNumber",
                  placeholder: _vm.$t("next_quote_number")
                },
                model: {
                  value: _vm.formData.currentQuoteNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "currentQuoteNumber", $$v)
                  },
                  expression: "formData.currentQuoteNumber"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              attrs: { label: _vm.$t("reset_quote_numbers"), "label-width": 3 }
            },
            [
              _c("sequential-number-reset-input", {
                model: {
                  value: _vm.formData.resetQuoteNumbers,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "resetQuoteNumbers", $$v)
                  },
                  expression: "formData.resetQuoteNumbers"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row gutter-x-md justify-start" }, [
      _c("div", { staticClass: "col-md-3 col-12" }, [
        _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
          _vm._v(_vm._s(_vm.$t("account_system")))
        ]),
        _c("p", { staticClass: "text-faded" }, [
          _vm._v(_vm._s(_vm.$t("account_system_hint")))
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-md-9 col-12" },
        [
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("account_system"),
                labelWidth: 3,
                error: _vm.errors.has("currentInvoiceNumber"),
                "error-label": _vm.errors.first("currentInvoiceNumber")
              }
            },
            [
              _c("q-select", {
                attrs: {
                  name: "accountSystem",
                  options: _vm.accountSystemOptions,
                  placeholder: _vm.$t("account_system")
                },
                model: {
                  value: _vm.formData.skrCodes,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "skrCodes", $$v)
                  },
                  expression: "formData.skrCodes"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "row justify-end" },
      [
        _c(
          "q-btn",
          {
            attrs: { type: "submit", color: "primary" },
            on: { click: _vm.handleSave }
          },
          [_vm._v(_vm._s(_vm.$t("save")))]
        )
      ],
      1
    ),
    _c("hr"),
    _c("div", { staticClass: "row gutter-x-md justify-start" }, [
      _c("div", { staticClass: "col-md-3 col-12" }, [
        _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
          _vm._v(_vm._s(_vm.$t("capture_imported_invoice")))
        ]),
        _c("p", {
          staticClass: "text-faded",
          domProps: { innerHTML: _vm._s(_vm.$t("import_invoice_hint")) }
        })
      ]),
      _c(
        "div",
        { staticClass: "col-md-9 col-12 self-center" },
        [
          _c(
            "q-btn",
            {
              attrs: {
                to: {
                  name: "pending-invoice-imports",
                  params: { teamId: this.activeTeam.id }
                },
                color: "primary"
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("import_invoices_label")) +
                  "\n      "
              )
            ]
          )
        ],
        1
      )
    ]),
    _c("hr"),
    _c("div", { staticClass: "row gutter-x-md justify-start" }, [
      _c("div", { staticClass: "col-md-3 col-12" }, [
        _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
          _vm._v(_vm._s(_vm.$t("pdf_template")))
        ]),
        _c("p", {
          staticClass: "text-faded",
          domProps: { innerHTML: _vm._s(_vm.$t("pdf_template_hint")) }
        })
      ]),
      !_vm.team.settings.pdf_template_set
        ? _c(
            "div",
            { staticClass: "col-md-9 col-12 self-center" },
            [
              _c("p", { staticClass: "text-faded" }, [
                _vm._v(_vm._s(_vm.$t("no_pdf_template")))
              ]),
              _c(
                "q-btn",
                {
                  attrs: { color: "primary" },
                  on: { click: _vm.handlePdfTemplateUploadClick }
                },
                [
                  _vm._v(
                    "\n        + " + _vm._s(_vm.$t("pdf_template")) + "\n      "
                  )
                ]
              ),
              _c("input", {
                ref: "templateInput",
                staticClass: "hidden file-input",
                attrs: { type: "file", accept: "application/pdf" },
                on: { change: _vm.handlePdfTemplateUpload }
              })
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "col-md-9 col-12 self-center" },
            [
              _c(
                "q-btn",
                {
                  attrs: { color: "danger", outline: "" },
                  on: { click: _vm.handleDeletePdfTemplate }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("pdf_template_delete_button")) +
                      "\n      "
                  )
                ]
              ),
              _c(
                "q-btn",
                {
                  staticClass: "q-ml-md",
                  attrs: { color: "primary", flat: "" },
                  on: { click: _vm.handleViewPdfTemplatePreview }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("view_preview")) + "\n      "
                  )
                ]
              )
            ],
            1
          )
    ]),
    _c("hr"),
    _c("div", { staticClass: "row gutter-x-md justify-start" }, [
      _c("div", { staticClass: "col-md-3 col-12" }, [
        _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
          _vm._v(_vm._s(_vm.$t("pdf_hidden_sections")))
        ]),
        _c("p", {
          staticClass: "text-faded",
          domProps: { innerHTML: _vm._s(_vm.$t("pdf_hidden_sections_hint")) }
        })
      ]),
      _c(
        "div",
        { staticClass: "col-md-9 col-12" },
        [
          _c("pdf-hidden-sections", {
            model: {
              value: _vm.hiddenPdfSections,
              callback: function($$v) {
                _vm.hiddenPdfSections = $$v
              },
              expression: "hiddenPdfSections"
            }
          })
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "row justify-end" },
      [
        _c(
          "q-btn",
          {
            attrs: { type: "submit", color: "primary" },
            on: { click: _vm.handleHiddenPdfSectionsSave }
          },
          [_vm._v(_vm._s(_vm.$t("save")))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }